"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var alert_helper_1 = require("./alert-helper");
var alert_style_1 = require("./alert-style");
var alert_type_1 = require("./alert-type");
function Alert(props) {
    var _a = props.status, status = _a === void 0 ? alert_type_1.AlertStatus.INFO : _a, className = props.className, restProps = __rest(props, ["status", "className"]);
    var icon = props.icon;
    if (!icon) {
        icon = (0, alert_helper_1.getDefaultIcon)(status);
    }
    return ((0, jsx_runtime_1.jsx)(alert_style_1.StyledSnackbar, __assign({}, restProps, { icon: icon, status: status, className: [className, "components-snackbar--".concat(status)].join(' ') })));
}
exports.Alert = Alert;
